import { ModelProp } from 'src/store/typings';
import CONSTANTS from 'src/store/constants';
import ClassifierMode from './classifier';
import ActuarialMode from './actuarial';

const ACT_MODEL_TYPES = CONSTANTS.TAL_MODEL.TAGS.slice(2);

export default function Fairness(props) {
  const modelType = props?.model?.dataModelType;
  if (modelType === 'CLASSIFIER') return ClassifierMode(props);
  if (ACT_MODEL_TYPES.includes(modelType)) return ActuarialMode(props);
  return null;
}

Fairness.propTypes = {
  model: ModelProp.isRequired,
};
